	
import React, { Component } from 'react';
import FormResults from './components/FormResults';
import 'sweetalert/dist/sweetalert.css';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import WaitingModal from '../../generics/WaitingModal';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';
import Parser from 'html-react-parser';

var Config = require('../../../config');
const {htmlToText} = require('html-to-text');

const style = {
  margin: 7,
};

class SampleResultForm extends Component{
	constructor(props) {
	    super(props);
	    this.saveItem = this.saveItem.bind(this);
	    this.cancel = this.cancel.bind(this);
	    this.getData = this.getData.bind(this);
	    this.state = {
	    	sample:{},
	    	results:[],
	    	validation:"",
	    	validated:false,
	    	donor_age:"",
	    	donor_name:"",
	    	donor_sex:"",
	    	person_id:"",
	    	validation_info:{},
			disable_save:false,
			show_btn_reserves: false
	    };
	}

	componentWillMount() {
		setTimeout(function(){
          this.getData();
        }.bind(this), 200);
  	}

  	getData(modal, validate){

  		if(modal !== false){
  			this.props.waiting.handleShow('Cargando...');
  		}
  		
  		fetch(Config.default.apiGateway.URL+
  			'samples/for_patients?petition_id='+this.props.match.params.petition_id+
  			'&samples_id='+this.props.match.params.sample_id+
  			'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Typet'	: 'application/json'
			})

		})
		.then(res => {
			//this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}})
		.catch(error => console.error('Error:', error))
		.then(response => {
			if(response !== undefined){
				var anti_patient = '';
				response.patient_antibodies.map((a)=>{
					return a.result === "1" ?
						anti_patient += a.antibody+',  '
					:null
				});
				anti_patient = anti_patient.substring(0,anti_patient.length-1);

				var phen_patient = '';
				response.patient_phenotypes.map((p)=>{
					return phen_patient += p.phenotype1+p.result+', ';
				});
				this.form.setState({
					fenotipo_donante: phen_patient,
					antibody_donante: anti_patient
				});

				if(response.print_info !== null){
					this.form.setState({
						print_info: response.print_info
					});
				}

				this.setState({
					sample: response.sample,
					results: response.results,
					validation: response.validation,
					validated:response.validated,
					donor_age: response.donor_age,
					donor_name: response.donor_name,
					donor_sex: response.sex,
					person_id: response.person_id,
					validation_info: response.validation_info,
					show_btn_reserves: response.type === 'COMPONENTS'
				});

				if(response.group_rh !== ""){
					this.form.setState({
						validation:response.validation, 
						donation_notes_id: response.donation_notes_id,
						person_group_rh: response.group_rh,
						person_lectina:response.lookup_lectin !== null ? response.lookup_lectin : "",
						person_du:response.du,
						enableAntibody:false
					});
				}else{
					this.form.setState({
						validation:response.validation, 
						donation_notes_id: response.donation_notes_id,
						enableAntibody:false
					});
				}

				if(response.total_sections > 0){
					this.form.setState({
						total_sections: response.total_sections,
						enableAntibody:false
					});
				}

				if(response.sample.historica !== null){
					this.form.setState({
						disableRemoveValidation: true
					});
				}
				console.log('get data', validate)
				this.form.getLabSections(validate);
				setTimeout(()=>{
					this.form.getfenotipoAntibody(response.sample.id, 'fenotipo_muestra');
					this.form.getfenotipoAntibody(response.sample.id, 'antibody_muestra');
				}, 500);
					

				this.getNotes(response.sample.patient_id);
				
			}
				
		});
  	}

  	getNotes(id){
		fetch(Config.default.apiGateway.URL+'petition_notes/alerts?patient_id='+id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(error) {
				swal('¡Error!', error, 'error');
			  });
			}
		})
		.then(response =>{
			if(response !== null && response !== undefined){
				if(response.alert !== null){
					
					if(response.alert.indexOf('<p>') === -1){
						swal('Alerta', htmlToText(response.alert), 'error');
					}else{
						swal({
							title: 'Alerta',
							html:true,
							text: response.alert,
							type: 'error',	
						});
					}


					
				}


				if(response.total > 0){

					this.setState({has_notes:true});
				}
			}
		})
	}

	cancel(e){
		if(this.props.history.location.state !== undefined){
			if(this.props.history.location.state.from.indexOf('/patient_search') !== -1){
				this.props.history.push('/patient_search/'+this.state.sample.patient_id);
			}else{
				this.props.history.goBack();
			}
		}else{

			this.props.history.goBack();
		}
	}

	//Funcion Submit Form
	saveItem(e, validate){
		e.preventDefault();
		if (this.state.disable_save) {
	        return;
	    }
		this.setState({disable_save:true});
    	var items = this.form.getResults();
 
    		this.props.waiting.handleShow('Guardando...');
    		
	      	fetch(Config.default.apiGateway.URL+'sample_results?sample_id='+this.props.match.params.sample_id, {
			  method: 'PUT', // or 'PUT'
			  body: JSON.stringify(items), // data can be `string` or {object}!
			  headers: new Headers({
			  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
			  	'Accept': 'application/json',
			  	'Content-Type': 'application/json;charset=UTF-8'
			  })
			})
			.then(res => {
		          //this.waiting_modal.handleClose();
		            if(res.ok){
		              return res.json();
		            }else{
		              res.text().then(function(error) {
		                swal('¡Error!', error, 'error');
		              });
		          }
		    })
			.then(response => {
		    	if(response !== undefined){
		    		this.setState({disable_save:false});
		    		notify.show('Registro Guardado','success');
					console.log('guardado', validate)
					this.getData(false, validate);					
		    	}
			});
	}

	//Contenido de la pantalla para el alta de un nuevo registro
	render(){
		const { t } = this.props;
		var donation_id = this.props.match.params.donation_id;
		return(
			<div className="col-xs-12" style={{paddingTop:"10px"}}>
				<h2 style={{textAlign:"center"}}>Resultado de la Muestra</h2>
		        <form noValidate>
		        	<FormResults {...this.props} state={this.state} onRef={ref => (this.form = ref)} 
						waiting_modal = {this.waiting_modal}
						saveItem={this.saveItem}
		        		getData={this.getData} validation={this.state.validation}/>
		        	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
		        	<Notifications />
		        </form>
		        <div className="col-xs-12" style={{textAlign:'center'}}>
		        	<RaisedButton className="action-btn" label="GRABAR" primary={true}
		        		 onClick={this.saveItem} style={style} disabled={this.state.disable_save}/>
	        		<RaisedButton className="action-btn" label="REGRESAR" primary={true} onClick={this.cancel} style={style}/>
		        </div>
		    </div>
		);
	}
}

export default translate('translations')(SampleResultForm)